import { render, staticRenderFns } from "./reglement.vue?vue&type=template&id=6478fcfa&"
import script from "./reglement.vue?vue&type=script&lang=js&"
export * from "./reglement.vue?vue&type=script&lang=js&"
import style0 from "./reglement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports